
// Constants used across vehicle components
export const VEHICLE_TYPES = [
  { value: "LIMO", label: "Limousine" },
  { value: "BUS", label: "Bus" },
  { value: "VAN", label: "Van" }
];

// Update years to go from 1975 to 2027
export const YEARS = Array.from({ length: 53 }, (_, i) => (2027 - i).toString());

// Amenities list
export const AMENITIES = [
  { id: "aux", label: "Aux" },
  { id: "speakers", label: "Speakers" },
  { id: "screens", label: "Screens" },
  { id: "refrigeration", label: "Refrigeration" },
  { id: "other", label: "Other" },
];
